type NamedLocation = { label?: string | null; hubName?: string | null };

type AddressedLocation = NamedLocation & {
  addressLine1?: string | null;
  city?: string | null;
  country?: string | null;
};

/**
 * What a location is called: its own label, else the name of the Hub it is placed at. An
 * unlabelled Hub venue stores no label, so a reader names the Hub while the `hub_id` link
 * exists; the caller passes `hubName` only then.
 */
export function locationName({ label, hubName }: NamedLocation): string | undefined {
  return label?.trim() || hubName?.trim() || undefined;
}

/**
 * The one line a server-composed text shows for a location (the dashboard's next session,
 * a booking-change notice): its name ({@link locationName}), else its address.
 */
export function locationDisplayLabel(location: AddressedLocation): string | undefined {
  return (
    locationName(location) ||
    [location.addressLine1, location.city, location.country].filter((part) => part?.trim()).join(', ') ||
    undefined
  );
}
